import { lazy, Suspense } from "react";
import { Navigate, RouteObject, useRoutes } from "react-router-dom";

import {
  LayoutSplashScreen,
  NotAuthorized,
  NotFound,
} from "../../components/core";
import PageLayout from "../../layouts/PageLayout";
import { isAuthorizedForResource, useAuth } from "../auth";
import { PackingListResource } from "./packing/List";
import { PickerWorkerlistListResource } from "./picker-worklist/List";
import { PickingListResource } from "./picking/List";

const PickingPage = lazy(() => import("./picking/List"));
const PackingPage = lazy(() => import("./packing/List"));
const PickerWorkerlistPage = lazy(() => import("./picker-worklist/List"));

const breadcrumbs = [
  {
    name: "Alpha Fresh",
    href: "/",
  },
  {
    name: "Pick & Pack",
    href: "/pickpack",
  },
];

export function PickpackPage() {
  const { currentRole } = useAuth();

  let routes: RouteObject[] = [
    {
      element: <PageLayout />,
      children: [
        {
          index: true,
          element: <Navigate to={PickingListResource.path} replace={true} />,
        },
        {
          path: PickingListResource.path,
          element: isAuthorizedForResource(
            currentRole,
            PickingListResource.access
          ) ? (
            <Suspense fallback={<LayoutSplashScreen />}>
              <PickingPage breadcrumbs={breadcrumbs} />
            </Suspense>
          ) : (
            <NotAuthorized
              error={new Error(PickingListResource.access.join(", "))}
            />
          ),
        },
        {
          path: PackingListResource.path,
          element: isAuthorizedForResource(
            currentRole,
            PackingListResource.access
          ) ? (
            <Suspense fallback={<LayoutSplashScreen />}>
              <PackingPage breadcrumbs={breadcrumbs} />
            </Suspense>
          ) : (
            <NotAuthorized
              error={new Error(PackingListResource.access.join(", "))}
            />
          ),
        },
        {
          path: PickerWorkerlistListResource.path,
          element: isAuthorizedForResource(
            currentRole,
            PickerWorkerlistListResource.access
          ) ? (
            <Suspense fallback={<LayoutSplashScreen />}>
              <PickerWorkerlistPage breadcrumbs={breadcrumbs} />
            </Suspense>
          ) : (
            <NotAuthorized
              error={new Error(PickerWorkerlistListResource.access.join(", "))}
            />
          ),
        },
      ],
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ];

  return useRoutes(routes);
}
